










































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  GetData,
  GetPro,
  GetTemplates,
  GetTemplate,
  AddIv,
  EditIv,
  DelIv,
  AddTemplate,
  DelTemplate,
  EditTem,
  ExportTem,
  ImportTem,
  getScoreFun,
  AddProject,
  DragSort,
  GetFanshiList,
  AddFanshi,
  EditFanshi,
  GetFanshiDetail,
  DelFanshi,
  EditFanshiTem,
  DelFanshiTem,
  DragFanshi,
  importTimu,
  exportTimu,
} from "@/request/tem";
import { LoginOut } from "@/request/account";
import TemplateTransfer from "@/components/template-transfer-pc/template-transfer/template-transfer.vue";
import {
  IfEmpty,
  hideContent,
  checkRequired,
} from "@/components/template-transfer-pc/template-transfer/common";
import LeaveConfirm from "@/components/dialogs/leaveConfirmDialog.vue";
import Empty from "@/components/empty.vue";
import Moban from "@/components/moban.vue";
import TemplateRead from "../components/template-read.vue";
import TemplateEdit from "../components/template-edit.vue";
import Transfer from "../components/transfer.vue";
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate",
]);
@Component({
  components: {
    TemplateTransfer,
    Empty,
    Moban,
    LeaveConfirm,
    TemplateRead,
    TemplateEdit,
    Transfer,
  },
})
export default class Name extends Vue {
  private defaultProps: any = {
    children: "temp_list",
    disabled: function (data: any, node: any) {
      if (data.temp_list) {
        return true;
      } else {
        return false;
      }
    },
  };
  private defaultProps2: any = {
    label: "name",
  };
  private cTab: any = "量表管理";
  private ifShowSaveConfirm: any = false;
  private noSaveText: any = "不保存，切换";
  private saveConfirmType: any = "";
  private target: any = {};
  private targetType: any = "";
  private edit: any = false;
  private curNavs: any = [];
  private currentNav: any = {};
  private ifShowYulan: any = false;
  private yulanData: any = [];
  private ifShowAddWenti: any = false;
  private ifShowAddLiangbiao: any = false;
  private ifShowMoban: any = false;
  private ifShowEditIv: any = false;
  private ifShowEditTem: any = false;
  private ifShowImport: any = false;
  private importProData: any = false; //项目导入量表暂存的数据
  private navs: any = [];
  private pageNavs: any = [];
  private mobanNavs: any = [];
  private templates: any = [];
  private addData: any = {};
  private editIvData: any = {};
  private editTemData: any = {};
  private data: any = [];
  private list: any = [];
  private curTem: any = {};
  private scoreFunList: any = [];
  private api: any = {};
  private addLiangbiaoData: any = {};
  private name: any = "";
  private proName: any = "";
  private proJihua: any = "";
  private ifShowAddName: any = false;
  private ifShowAddFangshi: any = false;
  private fangshis: any = [];
  private cFangshi: any = {};
  private editFangshiData: any = {
    name: "",
    type: "",
    time: null,
  };
  private fangshiType: any = "add"; //add or edit
  private suifangDetail: any = [];
  private IfShowTransfer: any = false;
  private get proData() {
    return this.$store.state.proData;
  }
  private allowDropFangshi(draggingNode: any, dropNode: any, type: any) {
    if (type == "inner") {
      return false;
    } else {
      return true;
    }
  }
  private nodeDropFangshi() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      data: this.fangshis,
    };
    DragFanshi(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success("移动成功");
        this.getFangshis();
      })
      .catch(() => {
        loading.close();
      });
  }
  private delFangshi(item: any) {
    this.$confirm(
      "您确定要删除该访视么？删除后该访视下的量表也将全部删除。",
      "删除",
      {
        customClass: "commonConfirm",
      }
    ).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        data: {
          visit_id: item.visit_id,
        },
      };
      DelFanshi(this, params, loading)
        .then((res: any) => {
          this.$message.success("删除成功!");
          this.cFangshi = {};
          this.getFangshis();
          loading.close();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private openYulanFangshi(item: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        temp_id: item.temp_id,
      },
    };
    GetTemplate(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.$store.commit("updateIfCompose", false);
        this.yulanData = JSON.parse(JSON.stringify(res["模板"]));
        this.ifShowYulan = true;
      })
      .catch(() => {
        loading.close();
      });
  }
  private moveOne(item: any) {
    this.$confirm("您是否确定移除当前量表？", "移除", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        data: {
          visit_id: this.cFangshi.visit_id,
          template_id: item.temp_id,
        },
      };
      DelFanshiTem(this, params, loading)
        .then((res: any) => {
          loading.close();
          this.$message.success("删除成功");
          this.getFangshiDetail();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private transferSave(e: any) {
    let arr: any = [];
    e.forEach((element: any) => {
      const d = JSON.parse(JSON.stringify(element));
      d.temp_list = [];
      element.temp_list.forEach((ele: any) => {
        if (!ele.hide) {
          delete ele.hide;
          delete ele.checked;
          d.temp_list.push(ele);
        }
      });
      arr.push(d);
    });
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      visit_id: this.cFangshi.visit_id,
      data: arr,
    };
    EditFanshiTem(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success("添加成功");
        this.IfShowTransfer = false;
        this.getFangshiDetail();
      })
      .catch(() => {
        loading.close();
      });
  }
  private openLiangbiaoSeiect() {
    this.IfShowTransfer = true;
  }
  private changeTab(val: any) {
    this.cTab = val;
    if (val == "访视计划") {
      this.getFangshis();
    }
  }
  private getFangshis() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        project_id: this.currentNav.project_id,
      },
    };
    GetFanshiList(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.fangshis = res;
        if (!this.cFangshi.visit_id) {
          if (res.length > 0) {
            this.cFangshi = res[0];
            this.initFangshi();
          }
        } else {
          this.fangshis.forEach((ele: any) => {
            if (ele.visit_id == this.cFangshi.visit_id) {
              this.cFangshi = ele;
              this.initFangshi();
            }
          });
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  private handleNodeClickFangshi(data: any, node: any) {
    this.cFangshi = data;
    this.initFangshi();
  }
  private initFangshi() {
    this.getFangshiDetail();
    setTimeout(() => {
      if (this.$refs.fangshiTree) {
        (this.$refs.fangshiTree as any).setCurrentKey(this.cFangshi);
      }
    }, 100);
  }
  private getFangshiDetail() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        project_id: this.currentNav.project_id,
        visit_id: this.cFangshi.visit_id,
      },
    };
    GetFanshiDetail(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.suifangDetail = res;
      })
      .catch(() => {
        loading.close();
      });
  }
  private openAddProName() {
    this.ifShowAddName = true;
    this.proName = "";
  }
  private openAddFangshi() {
    this.editFangshiData = {
      name: "",
      type: "",
      time: null,
    };
    this.fangshiType = "add";
    this.ifShowAddFangshi = true;
  }
  private editFangshi(item: any) {
    this.editFangshiData = JSON.parse(JSON.stringify(item));
    if (item.allow_time === "不限制") {
      this.editFangshiData.type = "不限制";
    } else {
      this.editFangshiData.type = "入组后";
      this.editFangshiData.time = item.allow_time.split("天")[0];
    }
    this.fangshiType = "edit";
    this.ifShowAddFangshi = true;
  }
  private addfangshi() {
    if (!this.editFangshiData.name) {
      this.$message.warning("请输入访视名称!");
      return;
    }
    if (!this.editFangshiData.type) {
      this.$message.warning("请选择访视时间!");
      return;
    }
    if (this.editFangshiData.type == "入组后" && !this.editFangshiData.time) {
      this.$message.warning("请填写访视时间!");
      return;
    }
    if (this.fangshiType == "add") {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        project_id: this.currentNav.project_id,
        allow_time: null,
        name: this.editFangshiData.name,
      };
      if (this.editFangshiData.type == "不限制") {
        params.allow_time = 0;
      }
      if (this.editFangshiData.type == "入组后") {
        params.allow_time = this.editFangshiData.time;
      }
      AddFanshi(this, params, loading)
        .then((res: any) => {
          loading.close();
          this.$message.success("新增访视成功！");
          this.ifShowAddFangshi = false;
          this.getFangshis();
        })
        .catch(() => {
          loading.close();
        });
    } else {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        visit_id: this.editFangshiData.visit_id,
        allow_time: null,
        name: this.editFangshiData.name,
      };
      if (this.editFangshiData.type == "不限制") {
        params.allow_time = 0;
      }
      if (this.editFangshiData.type == "入组后") {
        params.allow_time = this.editFangshiData.time;
      }
      EditFanshi(this, params, loading)
        .then((res: any) => {
          loading.close();
          this.$message.success("编辑访视成功！");
          this.ifShowAddFangshi = false;
          this.getFangshis();
        })
        .catch(() => {
          loading.close();
        });
    }
  }
  private addku() {
    if (!this.proName) {
      this.$message.warning("请输入专病库名称!");
      return;
    }
    if (!this.proJihua) {
      this.$message.warning("请选择访视计划!");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      名称: this.proName,
      visit_type: this.proJihua,
    };
    AddProject(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.ifShowAddName = false;
        this.getData();
      })
      .catch(() => {
        loading.close();
      });
  }
  private allowDrop(draggingNode: any, dropNode: any, type: any) {
    if (
      (draggingNode.data.temp_list && !dropNode.data.temp_list) ||
      (!draggingNode.data.temp_list && dropNode.data.temp_list) ||
      type == "inner"
    ) {
      return false;
    } else {
      return true;
    }
  }
  private nodeDrop() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      temp_data: this.templates,
    };
    DragSort(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.getTemplates();
      })
      .catch(() => {
        loading.close();
      });
  }

  private handleNodeClick(data: any, node: any) {
    if (!this.edit) {
      if (!data.temp_list) {
        this.curTem = data;
        this.$store.commit("updateCTemplate", this.curTem);
        this.init();
      } else {
        if (this.$refs.tree) {
          (this.$refs.tree as any).setCurrentKey(this.curTem);
        }
      }
    } else {
      this.noSaveText = "不保存，切换";
      this.target = JSON.parse(JSON.stringify(data));
      this.targetType = "量表";
      this.ifShowSaveConfirm = true;
    }
  }
  private init() {
    this.getTemplate();
    setTimeout(() => {
      if (this.$refs.tree) {
        (this.$refs.tree as any).setCurrentKey(this.curTem);
        // this.expandedNode = [this.currentNode["域id"]];
      }
    }, 100);
  }
  private update(e: any) {
    this.data["模板"] = e;
    this.forceUpdate();
  }
  private updateData(e: any) {
    this.data["模板"] = e;
    this.ifShowAddWenti = false;
  }
  private forceUpdate() {
    this.$forceUpdate();
  }
  // 保存确认弹框保存
  private changeSave() {
    this.ifShowSaveConfirm = false;
    if (this.saveConfirmType === "离开") {
      this.save().then(() => {
        this.$router.back();
      });
    } else {
      this.save().then(() => {
        if (this.targetType == "量表") {
          // this.selectTem(this.target);
          this.curTem = this.target;
          this.$store.commit("updateCTemplate", this.curTem);
          this.init();
          this.target = {};
        } else {
          this.clickNav(this.target);
          this.target = {};
        }
      });
    }
  }
  // 保存确认弹框不保存,切换
  private changeConfirmed() {
    this.ifShowSaveConfirm = false;
    this.edit = false;
    if (this.saveConfirmType === "离开") {
      this.$router.back();
    } else {
      if (this.targetType == "量表") {
        this.selectTem(this.target);
        this.target = {};
      } else {
        this.clickNav(this.target);
        this.target = {};
      }
    }
  }
  private editWenti(items: any) {
    this.addData = JSON.parse(JSON.stringify(items));
    this.ifShowAddWenti = true;
  }
  private delWenti(index: any) {
    this.data["模板"].splice(index, 1);
  }
  private openYulan() {
    this.$store.commit("updateIfCompose", true);
    this.yulanData = JSON.parse(JSON.stringify(this.data["模板"]));
    this.ifShowYulan = true;
  }
  private yulanSure() {
    const result: any = checkRequired(this.yulanData);
    if (!result.ifPass) {
      // 弹提示哪个未填,并用红框框上
      this.$message.warning(result.data.title + "为必填项！");
    } else {
      this.$message.success("验证成功");
    }
  }
  private updateWholeTem(e: any) {
    this.yulanData = e;
    this.$forceUpdate();
  }
  private updateYulanContent(e: any) {
    this.yulanData[e.index] = e.data;
    //计算BMI，量表顺序只能是身高，体重，BMI
    if (e.data.title === "身高") {
      const shengao = this.yulanData[e.index].value / 100;
      const tizhong = this.yulanData[e.index + 1].value;
      this.yulanData[e.index + 2].value = (
        tizhong /
        (shengao * shengao)
      ).toFixed(2);
    } else if (e.data.title === "体重") {
      const shengao = this.yulanData[e.index - 1].value / 100;
      const tizhong = this.yulanData[e.index].value;
      this.yulanData[e.index + 1].value = (
        tizhong /
        (shengao * shengao)
      ).toFixed(2);
    }
    this.$forceUpdate();
  }
  private handleProCommand(e: any) {
    if (e.type == "导出量表") {
      window.open(
        this.$store.state.API_ROOT +
          "api/project/temp/export?project_id=" +
          e.value.project_id +
          "&&t=" +
          new Date().getTime()
      );
    } else if (e.type == "导入量表") {
      this.importProData = e.value;
      this.ifShowImport = true;
    }
  }
  private handleIvCommand(e: any) {
    if (e.type == "删除") {
      this.delIv(e.value);
    } else if (e.type == "编辑") {
      this.openEditIv(e.value);
    }
  }
  private handleTemCommand(e: any) {
    if (e.type == "删除") {
      this.delTem(e.value);
    } else if (e.type == "编辑") {
      this.openEditTem(e.value);
    } else if (e.type == "导出") {
      this.exportOne(e.value);
    }
  }
  private exportOne(item: any) {
    window.open(
      this.$store.state.API_ROOT +
        "api/project/temp/export?project_id=" +
        this.currentNav.project_id +
        "&&temp_id=" +
        item.temp_id +
        "&&t=" +
        new Date().getTime()
    );
    return;
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        project_id: this.currentNav.project_id,
        temp_id: item.temp_id,
      },
    };
    ExportTem(this, params, loading)
      .then((res: any) => {
        loading.close();
        window.open(res.file_url);
        this.$message.success("导出成功！");
      })
      .catch(() => {
        loading.close();
      });
  }
  private uploadFile(item: any, d: any) {
    const fileObj = d.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("project_id", this.currentNav.project_id);
    form.append("iv_id", item.iv_id);
    form.append("file", fileObj);
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    ImportTem(this, form, loading)
      .then((data: any) => {
        loading.close();
        this.$message.success("导入成功!");
        this.getTemplates();
      })
      .catch(() => {
        loading.close();
      });
  }
  private uploadProFile(d: any) {
    this.ifShowImport = false;
    const fileObj = d.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("project_id", this.importProData.project_id);
    form.append("file", fileObj);
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    ImportTem(this, form, loading)
      .then((data: any) => {
        loading.close();
        this.$message.success("导入成功!");
        this.getTemplates();
      })
      .catch(() => {
        loading.close();
      });
  }
  private changeOpen(item: any) {
    item.hide = !item.hide;
    this.$forceUpdate();
  }
  private exit() {
    this.$confirm("您是否确定退出当前系统？", "退出", {
      customClass: "commonConfirm",
    }).then(() => {
      if (this.currentNav["project_name"] !== "慢病") {
        localStorage.removeItem("token");
        this.$router.push("/login");
      } else {
        LoginOut(this).then((res: any) => {
          localStorage.removeItem("token");
          this.$router.push("/login");
        });
      }
    });
  }
  private openMuban() {
    this.ifShowMoban = true;
  }
  private openAddLiangbiao() {
    if (this.edit) {
      this.$message.warning("请先保存当前量表内容");
      return;
    }
    this.addLiangbiaoData = {
      模板类型: "自定义模板",
      is_score: false,
      is_required: false,
      func: {},
    };
    // 获取计分函数
    this.getFuns();
    this.ifShowAddLiangbiao = true;
  }
  private getFuns() {
    getScoreFun(this).then((res: any) => {
      this.scoreFunList = res;
    });
  }
  private addLiangbiao() {
    if (!this.addLiangbiaoData.type || !this.addLiangbiaoData.type.iv_name) {
      this.$message.warning("请选择分类!");
      return;
    }
    if (
      this.addLiangbiaoData.type.iv_name === "新增分类" &&
      !this.addLiangbiaoData.typeName
    ) {
      this.$message.warning("请输入分类名称!");
      return;
    }
    if (!this.addLiangbiaoData.name) {
      this.$message.warning("请填写量表名称!");
      return;
    }
    if (!this.addLiangbiaoData["模板类型"]) {
      this.$message.warning("请选择模板类型!");
      return;
    }
    // 如果是计分量表，需要选择计分函数
    if (
      this.addLiangbiaoData["is_score"] &&
      !this.addLiangbiaoData["func"].func
    ) {
      this.$message.warning("请选择计分方式!");
      return;
    }
    if (this.addLiangbiaoData.type.iv_name === "新增分类") {
      this.addIv().then((d: any) => {
        this.addLiangbiaoData.type.iv_id = d.iv_id;
        this.addTem();
      });
    } else {
      this.addTem();
    }
    this.ifShowAddLiangbiao = false;
  }
  private addIv() {
    return new Promise((resolve, reject) => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        project_id: this.currentNav.project_id,
        iv_name: this.addLiangbiaoData.typeName,
      };
      AddIv(this, params, loading)
        .then((data: any) => {
          loading.close();
          resolve(data);
        })
        .catch(() => {
          loading.close();
          reject();
        });
    });
  }
  private delIv(item: any) {
    if (this.edit) {
      this.$message.warning("请先保存当前量表");
      return;
    }
    this.$confirm("您是否确定删除当前分类吗？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        data: {
          iv_id: item.iv_id,
        },
      };
      DelIv(this, params, loading)
        .then(() => {
          loading.close();
          this.$message.success("删除成功！");
          this.getTemplates();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private openEditIv(item: any) {
    this.editIvData = JSON.parse(JSON.stringify(item));
    this.ifShowEditIv = true;
  }
  private editIv() {
    if (!this.editIvData.iv_name) {
      this.$message.warning("请输入分类名称！");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      iv_id: this.editIvData.iv_id,
      iv_name: this.editIvData.iv_name,
    };
    EditIv(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success("编辑成功！");
        this.ifShowEditIv = false;
        this.getTemplates();
      })
      .catch(() => {
        loading.close();
      });
  }
  private addTem() {
    return new Promise((resolve, reject) => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        iv_id: this.addLiangbiaoData.type.iv_id,
        form_oid: this.addLiangbiaoData["编码"],
        category: this.addLiangbiaoData["模板类型"],
        temp_name: this.addLiangbiaoData.name,
        profile: this.addLiangbiaoData.profile,
        is_required: this.addLiangbiaoData.is_required,
        is_score: this.addLiangbiaoData.is_score,
        func: this.addLiangbiaoData.func,
      };
      AddTemplate(this, params, loading)
        .then((data: any) => {
          loading.close();
          this.$message.success("新增成功！");
          this.getTemplates();
          resolve(data);
        })
        .catch(() => {
          loading.close();
          reject();
        });
    });
  }
  private delTem(item: any) {
    if (this.edit) {
      this.$message.warning("请先保存当前量表");
      return;
    }
    this.$confirm("您是否确定删除当前量表吗？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        data: {
          temp_id: item.temp_id,
        },
      };
      DelTemplate(this, params, loading)
        .then(() => {
          loading.close();
          // if (this.curTem.temp_id == item.temp_id) {
          //   this.edit = false;
          // }
          this.$message.success("删除成功！");
          this.curTem = {};
          this.$store.commit("updateCTemplate", this.curTem);
          this.getTemplates();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private openEditTem(item: any) {
    this.editTemData = JSON.parse(JSON.stringify(item));
    this.editTemData.name = this.editTemData.temp_name;
    this.editTemData["模板类型"] = this.editTemData.category;
    this.getFuns();
    this.ifShowEditTem = true;
  }
  private editTem() {
    if (!this.editTemData.name) {
      this.$message.warning("请填写量表名称!");
      return;
    }
    if (!this.editTemData["模板类型"]) {
      this.$message.warning("请选择模板类型!");
      return;
    }
    // 如果是计分量表，需要选择计分函数
    if (this.editTemData["is_score"] && !this.editTemData["func"].func) {
      this.$message.warning("请选择计分方式!");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      temp_id: this.editTemData.temp_id,
      temp_name: this.editTemData.name,
      category: this.editTemData["模板类型"],
      profile: this.editTemData.profile,
      is_score: this.editTemData.is_score,
      is_required: this.editTemData.is_required,
      func: this.editTemData.func,
    };
    EditTem(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success("编辑成功！");
        this.ifShowEditTem = false;
        this.getTemplates();
      })
      .catch(() => {
        loading.close();
      });
  }
  private addWentiSure() {
    if (!this.addData.type) {
      this.$message.warning("请选择类型");
      return;
    }
    if (this.addData.options && this.addData.options.length == 0) {
      this.$message.warning("请添加选项");
      return;
    }
    if (
      (this.addData.type == "搜索多选" || this.addData.type == "目录式多选") &&
      !this.addData.search
    ) {
      this.$message.warning("请输入搜索类型");
      return;
    }
    if (this.addData.type == "图片" && !this.addData.url) {
      this.$message.warning("请输入地址");
      return;
    }
    if (this.addData.type == "图片" && !this.addData.width) {
      this.$message.warning("请输入宽度");
      return;
    }
    if (this.addData.type == "压痛点" && !this.addData.setting) {
      this.$message.warning("请选择压痛点类型");
      return;
    }
    // 自动生成id
    if (!this.addData.id) {
      this.addData.id = new Date().getTime();
      // 主标题和段落标题没有value字段
      // 文本的value字段不能清除，否则新增时会被清除掉
      if (
        this.addData.type !== "主标题" &&
        this.addData.type !== "段落标题" &&
        this.addData.type !== "文本"
      ) {
        if (
          this.addData.type == "计分单选" ||
          this.addData.type == "sf36计分单选" ||
          this.addData.type == "压痛点"
        ) {
          this.addData.value = {};
        } else if (
          this.addData.type == "多选" ||
          this.addData.type == "搜索多选" ||
          this.addData.type == "目录式多选" ||
          this.addData.type == "文件" ||
          this.addData.type == "视频"
        ) {
          this.addData.value = [];
        } else if (this.addData.type == "家庭住址") {
          this.addData.value = [[], ""];
        } else if (
          this.addData.type == "中药饮片信息" ||
          this.addData.type == "其它用药信息"
        ) {
          this.addData.value = { 饮片: [{}] };
        } else {
          this.addData.value = "";
        }
      }
      this.data["模板"].push(this.addData);
    } else {
      this.data["模板"].forEach((ele: any, i: any) => {
        if (ele.id == this.addData.id) {
          this.$set(this.data["模板"], i, this.addData);
        }
      });
    }
    this.$forceUpdate();
    this.ifShowAddWenti = false;
  }
  private openAddTimu() {
    this.ifShowAddWenti = true;
    this.addData = {
      type: "主标题",
      is_required: false,
      hide: false,
    };
  }

  private clickNav(item: any) {
    if (!this.edit) {
      this.currentNav = item;
      this.curTem = {};
      this.$store.commit("updateCTemplate", this.curTem);

      this.$forceUpdate();
      this.getTemplates();
    } else {
      this.noSaveText = "不保存，切换";
      this.target = JSON.parse(JSON.stringify(item));
      this.targetType = "项目";
      this.ifShowSaveConfirm = true;
    }
  }
  private getTemplates() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        project_id: this.currentNav.project_id,
      },
    };
    GetTemplates(this, params, loading)
      .then((res: any) => {
        loading.close();
        res.forEach((element: any) => {
          // 需要生成唯一识别，目前是在最外层生成一个temp_id，这样就可以用temp_id作为唯一识别
          element.temp_id = element.iv_id;
          if (element.temp_list && element.temp_list.length > 0) {
            element.temp_list.forEach((ele: any) => {
              ele.iv_id = element.iv_id;
            });
          }
        });
        this.templates = res;
        if (!this.curTem.temp_id) {
          if (
            this.templates[0].temp_list &&
            this.templates[0].temp_list.length > 0
          ) {
            this.selectTem(this.templates[0].temp_list[0]);
          }
        } else {
          // 更新当前模板信息
          res.forEach((element: any) => {
            if (element.temp_list && element.temp_list.length > 0) {
              element.temp_list.forEach((ele: any) => {
                if (ele.temp_id == this.curTem.temp_id) {
                  this.curTem = ele;
                  this.$store.commit("updateCTemplate", this.curTem);
                  this.$forceUpdate();
                }
              });
            }
          });
          this.init();
          // this.getTemplate();
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  private selectTem(item: any) {
    if (!this.edit) {
      this.curTem = item;
      this.$store.commit("updateCTemplate", this.curTem);
      this.init();
      // this.getTemplate();
    } else {
      this.noSaveText = "不保存，切换";
      this.target = JSON.parse(JSON.stringify(item));
      this.targetType = "量表";
      this.ifShowSaveConfirm = true;
    }
  }
  private getTemplate() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        temp_id: this.curTem.temp_id,
      },
    };
    GetTemplate(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data = res;
      })
      .catch(() => {
        loading.close();
      });
  }
  private importData(e: any) {
    this.ifShowMoban = false;
  }
  private getData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetPro(this, loading)
      .then((res: any) => {
        loading.close();
        this.navs = res;
        if (this.navs.length === 1 && this.navs[0]["project_name"] == "慢病") {
          this.navs[0].noPro = true;
          this.currentNav = this.navs[0];
          this.getTemplates();
        } else {
          if (this.navs.length > 0 && !this.currentNav.project_id) {
            this.clickNav(this.navs[0]);
          } else {
            this.getTemplates();
          }
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  private saveData() {
    // return;
    this.save().then(() => {
      this.getData();
    });
  }
  private save() {
    return new Promise((resolve, reject) => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        temp_id: this.curTem.temp_id,
        temp_data: this.data["模板"],
      };
      EditTem(this, params, loading)
        .then(() => {
          loading.close();
          this.$message.success("保存成功！");
          this.edit = false;
          resolve(true);
        })
        .catch(() => {
          loading.close();
          reject();
        });
    });
  }
  /**
   * @description 离开页面前保存
   */
  private beforeRouteLeave(to: any, from: any, next: any) {
    if (this.edit) {
      this.saveConfirmType = "离开";
      this.noSaveText = "不保存，离开";
      this.ifShowSaveConfirm = true;
      next(false);
    } else {
      next(true);
    }
  }
  /**
   * 导入题目
   */
  private uploadTimuFile(d: any) {
    const fileObj = d.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("temp_id", this.curTem.temp_id);
    form.append("file", fileObj);
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    importTimu(this, form, loading)
      .then((data: any) => {
        loading.close();
        this.$message.success("导入成功!");
        this.getTemplate();
      })
      .catch(() => {
        loading.close();
      });
  }
  /**
   * 导出题目
   */
  private exportTimu() {
    let arr: any = [];
    this.data["模板"].forEach((ele: any) => {
      if (ele.checked) {
        const obj = JSON.parse(JSON.stringify(ele));
        if (obj.control) {
          obj.control = [];
        }
        delete obj.checked;
        arr.push(obj);
      }
    });
    if (arr.length == 0) {
      this.$message.warning("请选择需要导出的题目");
      return;
    }
    const data: any = {
      模板: arr,
    };
    const jsonString = JSON.stringify(data);
    const blob = new Blob([jsonString], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "data.json";
    link.click();
    return;
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      temp_id: this.curTem.temp_id,
      sub_id: arr,
    };
    exportTimu(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.$message.warning("导出成功！");
        this.getTemplate();
        window.open(res.file_path);
      })
      .catch(() => {
        loading.close();
      });
  }

  private mounted() {
    this.pageNavs = JSON.parse(JSON.stringify(this.navs));
    this.mobanNavs = JSON.parse(JSON.stringify(this.navs));
    this.getData();
  }
}
